import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHeader = ({ title, description, keywords }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            {/* Add more meta tags as needed */}
        </Helmet>
    );
};

export default SEOHeader;
